<template>
  <md-card>
    <md-card-content>
      <div class="shortcut-form-line">
        <div
          v-if="isVariantMode"
          class="variant-slug-input"
        >
          <md-field>
            <label>Slug</label>
            <md-input
              v-model="shortcut.slug"
              disabled
            />
            <div
              v-if="submitted && validation.slug.$error"
              class="error-feedback"
            >
              Must be a valid variant name
            </div>
          </md-field>

          <md-field>
            <label>Slug suffix</label>
            <md-input v-model="slugSuffix" />
          </md-field>
        </div>
        <md-field v-else>
          <label>Slug</label>
          <md-input v-model="shortcut.slug" />
          <div
            v-if="submitted && validation.slug.$error"
            class="error-feedback"
          >
            Must be a valid variant name
          </div>
        </md-field>
      </div>

      <br>
      <two-language-input
        v-model="shortcut.title"
        label="Title"
        :validation="validation.title"
        inline
      />

      <two-language-input
        v-model="shortcut.subtitle"
        label="Subtitle"
        inline
      />

      <md-field>
        <label>Read more link</label>
        <md-input v-model="shortcut.read_more_link" />
      </md-field>

      <two-language-input
        v-model="shortcut.short_title"
        label="Short title"
        inline
      />

      <div class="shortcut-form-line">
        <md-field>
          <label>Category</label>
          <md-input v-model="shortcut.category" />
          <div
            v-if="submitted && !validation.title.required"
            class="error-feedback"
          >
            Field is required
          </div>
        </md-field>
      </div>

      <div class="shortcut-form-line">
        <md-field style="margin-right: 30px">
          <label>Type</label>
          <md-select
            id="type"
            v-model="shortcut.type"
            name="type"
          >
            <md-option value="General">
              General
            </md-option>
            <md-option value="Detailed">
              Detailed
            </md-option>
            <md-option value="Universal">
              Universal
            </md-option>
          </md-select>
          <div
            v-if="submitted && !validation.type.required"
            class="error-feedback"
          >
            Field is required
          </div>
        </md-field>
        <md-field>
          <label>Layout style</label>
          <md-select
            id="layout-style"
            v-model="shortcut.layout_style"
            name="layout-style"
          >
            <md-option value="small">
              Small
            </md-option>
            <md-option value="medium">
              Medium
            </md-option>
            <md-option value="large">
              Large
            </md-option>
          </md-select>
        </md-field>
      </div>

      <md-field>
        <label>Comment</label>
        <md-textarea v-model="shortcut.comment" />
      </md-field>

      <md-field>
        <label>Keywords</label>
        <md-textarea v-model="shortcut.keywords" />
      </md-field>

      <div class="shortcut-form-line">
        <md-field class="index-field">
          <label>Index</label>
          <md-input v-model="shortcut.index" />
        </md-field>

        <md-checkbox v-model="shortcut.enabled">
          Enabled
        </md-checkbox>

        <md-checkbox v-model="shortcut.premium">
          Premium
        </md-checkbox>

        <md-checkbox v-model="shortcut.requires_age_confirmation">
          Requires Age Confirmation
        </md-checkbox>

        <md-checkbox v-model="shortcut.sensitive">
          Sensitive
        </md-checkbox>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
    import TwoLanguageInput from "../Fields/TwoLanguageInput";

    export default {
        components: { TwoLanguageInput },
        props: {
          shortcut: { type: Object, required: true },
          validation: { type: Object, required: true },
          submitted: Boolean,
          isVariantMode: Boolean
        },
        data() {
            return {
                slugSuffix: ""
            };
        },
        watch: {
            slugSuffix: "onSuffixChange"
        },
        methods: {
            onSuffixChange(suffix) {
                if (!suffix) {
                    this.shortcut.slug = this.shortcut.slug.split("_")[0];
                } else if (this.shortcut.slug.includes("_")) {
                    this.shortcut.slug = this.shortcut.slug.split("_")[0] + "_" + suffix;
                } else {
                    this.shortcut.slug += "_" + suffix;
                }
            }
        }
    };
</script>
<style lang="scss">
    .shortcut-form-line {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        margin-top: 10px;

        .index-field {
            width: 25%;
        }

        .md-field {
            margin: 0;
        }
        .md-checkbox {
            margin: 0;
            padding-top: 18px;
        }
    }

    .variant-slug-input {
        width: 100%;
        flex-grow: 2;
        display: flex;
    }

    .error-feedback {
        font-size: 12px;
        color: red;
        margin-right: 5px;
    }

    @media only screen
    and (max-width: 850px) {
        .shortcut-form-line {
            flex-direction: column;
        }

        .index-field {
            width: 100% !important;
        }
    }
    @-webkit-media only screen and (max-width: 850px) {
        .shortcut-form-line {
            flex-direction: column;
        }

        .index-field {
            width: 100% !important;
        }
    }
</style>
